import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgProgressModule } from 'ngx-progressbar';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';  
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import {LocationStrategy, HashLocationStrategy, PathLocationStrategy, DatePipe, APP_BASE_HREF} from '@angular/common';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthGaurd } from './auth.service';
import { AngularFireModule } from'angularfire2';
import { AdminsComponent } from './users/admins/admins.component';
import { DriversComponent } from './users/drivers/drivers.component';
import { CalendarModule } from 'angular-calendar';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgDragDropModule } from 'ng-drag-drop';
import { VehiclesComponent } from './fleet-management/vehicles/vehicles.component';
import { environment } from '../environments/environment.prod';
import { QRCodeModule } from 'ng-qrcode';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AngularFireDatabase } from 'angularfire2/database';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgPipesModule }    from 'ngx-pipes';
import { AgmCoreModule } from '@agm/core';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { UserService } from './users/shared/user.service';
import { ManageAdminComponent } from './users/admins/manage-admin/manage-admin.component';
import { ManageDriverComponent } from './users/drivers/manage-driver/manage-driver.component';
import { BranchesComponent } from './branches/branches.component';
import { ManageBranchComponent } from './branches/manage-branch/manage-branch.component';
import { AddShipmentComponent } from './logistics-operations/add-shipment/add-shipment.component';
import { ManageShipmentComponent } from './logistics-operations/manage-shipment/manage-shipment.component';
import { ViewShipmentDetailsComponent } from './logistics-operations/view-shipment-details/view-shipment-details.component';
import { BarcodeComponent } from './logistics-operations/barcode/barcode.component';
import { MessagingService } from './messagingservice';
import { FinanceComponent } from './logistics-operations/finance/finance.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { ManageCustomerComponent } from './users/customers/manage-customer/manage-customer.component';
import { ContactsComponent } from './users/contacts/contacts.component';
import { CitiesComponent } from './logistics-operations/cities/cities.component';
import { DashboardAdminComponent } from './logistics-operations/dashboard-main/dashboard-admin/dashboard-admin.component';
import { DashboardSuperadminComponent } from './logistics-operations/dashboard-main/dashboard-superadmin/dashboard-superadmin.component';
import { DashboardMainComponent } from './logistics-operations/dashboard-main/dashboard-main.component';
import { Section11Component } from './logistics-operations/dashboard-main/section1-1/section1-1.component';
import { Section12Component } from './logistics-operations/dashboard-main/section1-2/section1-2.component';
import { Section21Component } from './logistics-operations/dashboard-main/section2-1/section2-1.component';
import { Section22Component } from './logistics-operations/dashboard-main/section2-2/section2-2.component';
import { Section13Component } from './logistics-operations/dashboard-main/section1-3/section1-3.component';
import { Section31Component } from './logistics-operations/dashboard-main/section3-1/section3-1.component';
import { Section32Component } from './logistics-operations/dashboard-main/section3-2/section3-2.component';
import { ExpensesComponent } from './fleet-management/expenses/expenses.component';
import { CustomersComponent } from './users/customers/customers.component';
import { SettingsComponent } from './settings/settings.component';
import { HrmsComponent } from './hrms/hrms.component';
import { EmployeeComponent } from './hrms/employee/employee.component';
import { LeavesComponent } from './hrms/leaves/leaves.component';
import { SupervisorsComponent } from './users/supervisors/supervisors.component';
import { AttendanceComponent } from './hrms/attendance/attendance.component';
import { UserProfilePageComponent } from './layouts/user-profile-page/user-profile-page.component';
import { CompanyComponent } from './hrms/company/company.component';
import { HolidaysComponent } from './hrms/holidays/holidays.component';
import { PayrollComponent } from './hrms/payroll/payroll.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {SelectModule} from 'ng-select';
import { GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { NgxPaginationModule } from 'ngx-pagination';
import { HRMSService } from './hrms/shared/hrms.service';
import { SearchComponent } from './hrms/employee/search/search.component';
import { OnboardComponent } from './hrms/employee/onboard/onboard.component';
import { OffboardComponent } from './hrms/employee/offboard/offboard.component';
import { ProgressbarModule } from 'ngx-bootstrap';
import { UtilService } from './hrms/shared/util.service';
import { LogisticsService } from './logistics-operations/shared/logistics.service';
import { SessionService } from './sessions/session.service';
import { TestcomponentComponent } from './testcomponent/testcomponent.component';
import { LeavesDashboardComponent } from './hrms/leaves/leaves-dashboard/leaves-dashboard.component';
import { DateService } from './date/date.service';
import { VisaExpiryComponent } from './hrms/overview/visa-expiry/visa-expiry.component'
import { VehicleAddComponent } from './fleet-management/vehicle-add/vehicle-add.component';
import { VehicleInspectionComponent } from './fleet-management/vehicle-inspection/vehicle-inspection.component';
import { FleetDashboardComponent } from './fleet-management/fleet-dashboard/fleet-dashboard.component';
import { FleetSettingsComponent } from './fleet-management/fleet-settings/fleet-settings.component';
import { ViewEmployeeDetailsComponent } from './hrms/employee/view-employee-details/view-employee-details.component';
import { UploadService } from './uploads/shared/upload.service';
import { UsersComponent } from './users/users.component';
import { CompanyService } from './hrms/shared/company.service';
import { FinanceDashboardComponent } from './finance-management/finance-dashboard/finance-dashboard.component';
import { FinanceSettingsComponent } from './finance-management/finance-settings/finance-settings.component';
import { FinanceTransactionsComponent } from './finance-management/finance-transactions/finance-transactions.component';
import { SalaryComponent } from './hrms/payroll/salary/salary.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { FinanceService } from './finance-management/shared/finance.service';
import { ProfitLossComponent } from './finance-management/profit-loss/profit-loss.component';
import { CommonService } from './common.service';
import { AttendanceTabMeComponent } from './hrms/attendance/attendance-tab-me/attendance-tab-me.component';
import { AttendanceTabTeamComponent } from './hrms/attendance/attendance-tab-team/attendance-tab-team.component';
import { AttendanceTabApprovalsComponent } from './hrms/attendance/attendance-tab-approvals/attendance-tab-approvals.component';
import { FinanceAccountComponent } from './finance-management/finance-account/finance-account.component';
import { SettingsService } from './settings/settings.service';
import { NotificationLayoutComponent } from './layouts/admin/notification-layout/notification-layout.component';
import {FormlyModule} from '@ngx-formly/core';
import { BranchWiseAttendanceComponent } from './hrms/overview/branch-wise-attendance/branch-wise-attendance.component';
import { RepeatTypeComponent } from './finance-management/shared/repeat-section.type';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import { UniversalSearchComponent } from './logistics-operations/universal-search/universal-search.component';

export function minValidationMessage(err, field) {
  return `This value should be more than ${field.templateOptions.min}`;
}

export function maxValidationMessage(err, field) {
  return `This value should be less than ${field.templateOptions.max}`;
} 

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    BreadcrumbsComponent,
    TitleComponent,
    AdminsComponent,
    DriversComponent,
    VehiclesComponent,
    ManageAdminComponent,
    ManageDriverComponent,
    BranchesComponent,
    ManageBranchComponent,
    AddShipmentComponent,
    ManageShipmentComponent,
    ViewShipmentDetailsComponent,
    BarcodeComponent,
    FinanceComponent,
    ManageCustomerComponent,
    ContactsComponent,
    CustomersComponent,
    CitiesComponent,
    DashboardAdminComponent,
    DashboardSuperadminComponent,
    DashboardMainComponent,
    Section11Component,
    Section12Component,
    Section21Component,
    Section22Component,
    Section13Component,
    Section31Component,
    Section32Component,
    ExpensesComponent,
    SettingsComponent,
    HrmsComponent,
    EmployeeComponent,
    LeavesComponent,
    SupervisorsComponent,
    AttendanceComponent,
    UserProfilePageComponent,
    CompanyComponent,
    HolidaysComponent,
    PayrollComponent,
    SearchComponent,
    OnboardComponent,
    OffboardComponent,
    TestcomponentComponent,
    LeavesDashboardComponent,
    VisaExpiryComponent,
    VehicleAddComponent,
    VehicleInspectionComponent,
    FleetDashboardComponent,
    FleetSettingsComponent,
    ViewEmployeeDetailsComponent,
    UsersComponent,
    FinanceDashboardComponent,
    FinanceSettingsComponent,
    FinanceTransactionsComponent,
    SalaryComponent,
    ProfitLossComponent,
    AttendanceTabMeComponent,
    AttendanceTabTeamComponent,
    AttendanceTabApprovalsComponent,
    FinanceAccountComponent,
    NotificationLayoutComponent,
    BranchWiseAttendanceComponent,
    RepeatTypeComponent,
    UniversalSearchComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgProgressModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes),
    FormsModule,
    HttpModule,
    CalendarModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseconfig),
    NgbModalModule.forRoot(),
    NgDragDropModule.forRoot(),
    QRCodeModule,
    PdfViewerModule,
    HttpClientModule,
    Ng2SearchPipeModule,
    NgPipesModule,
    NgxBarcodeModule,
    BsDropdownModule.forRoot(),
    ModalModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    SelectModule,
    GridModule,
    ExcelModule,
    PDFModule,
    ChartsModule,
    NgxPaginationModule,
    FormlyBootstrapModule,
    AgmCoreModule.forRoot({
      //apiKey: 'AIzaSyCrkB6MEFfTcU_4YjGnWytZr3vlMGeUovE'
      apiKey: 'AIzaSyAc8mzdgz2T6nDzPHXpKn_fb94fDGMW9LI'
    }),
    ProgressbarModule.forRoot(),
    ReactiveFormsModule,
    FormlyModule.forRoot({
      validationMessages: [
        { name: 'required', message: 'This field is required' },
        { name: 'min', message: minValidationMessage },
        { name: 'max', message: maxValidationMessage },
      ],
      types: [
        { name: 'repeat', component: RepeatTypeComponent }
      ]
    })
  ],
  providers: [
    AngularFireAuth,
    AngularFireDatabase,
    UserService,
    HRMSService,
    FinanceService,
    MessagingService,
    UtilService,
    DatePipe,
    AuthGaurd,
    LogisticsService,
    SessionService,
    DateService,
    UploadService,
    CommonService,
    CompanyService,
    SettingsService,
      { provide: LocationStrategy, useClass: HashLocationStrategy }, { provide: APP_BASE_HREF, useValue: '/' }
      
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/app.module.ts